import React from 'react'

const scrollToSection = (id, closeFn) => {
    closeFn();
    setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
            const headerOffset = document.querySelector('.header-wrap')?.offsetHeight || 80;
            const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    }, 300);
};

const MobileMenuTwo = ({ mobileMenu, handleMobileMenu }) => {

    return (
        <>
            <div>
                <div className={mobileMenu ? 'mobile-nav' : 'mobile-nav show'}>
                    <button onClick={handleMobileMenu} type="button" className="close-nav">
                        <i className="fal fa-times-circle"></i>
                    </button>
                    <nav className="sidebar-nav">
                        <ul className="metismenu" id="mobile-menu">
                            <li>
                                <ul className="sub-menu">
                                    <li><a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home', handleMobileMenu); }}>Home</a></li>
                                    <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services', handleMobileMenu); }}>Services</a></li>
                                    <li><a href="#why-choose-us" onClick={(e) => { e.preventDefault(); scrollToSection('why-choose-us', handleMobileMenu); }}>Why Choose Us</a></li>
                                    <li><a href="#amc-packages" onClick={(e) => { e.preventDefault(); scrollToSection('amc-packages', handleMobileMenu); }}>AMC Packages</a></li>
                                </ul>
                            </li>
                            {/* <li><Link to="/about">about us</Link></li>
                    <li><Link to="/services">Services</Link></li>
                    <li>
                        <a className="has-arrow" href="#">Pages</a>
                        <ul className="sub-menu">
                            <li><Link to="/faq">faq</Link></li>
                            <li><Link to="/pricing">Pricing</Link></li>
                            <li><Link to="/team">Team</Link></li>
                        </ul>
                    </li> */}
                            {/* <li><Link to="/news">News</Link></li>
                    <li><Link to="/contact">Contact</Link></li> */}
                        </ul>
                    </nav>


                    <div className="action-bar offset-bar">
                        <a className="has-arrow" href="#">CONTACT INFO</a>
                        <a href=""><i className="fal fa-map"></i>DH Tech Building Contracting LLC
                            <p>Rubaya Building, AI Qusais Dubai, UAE</p></a>
                        <a href="mailto:info@dhtech.ae"><i className="fal fa-envelope"></i>info@dhtech.ae</a>
                        <a href="tel:+971 4 380 9355"><i className="fal fa-phone"></i>+971502033924</a>
                        <a href="tel:+971 4 380 9355"><i className="fal fa-clock"></i>Week Days: 8:00 AM - 6:00 PM</a>
                        <a href="https://wa.me/971502033924"
                            target="_blank" className="d-btn theme-btn"> Consultation</a>
                    </div>
                </div>
            </div>
            {!mobileMenu && <div className="mobile-menu-backdrop" onClick={handleMobileMenu} ></div>}
        </>

    )
}

export default MobileMenuTwo